import { gql } from "apollo-boost";

export const fragments = {
  franchise: gql`
    fragment FranchiseQueryFranchise on Franchise {
      id
      name
      slug
      assignedInHouseTty
      corporateName
      deactivated
    }
  `
};

export default gql`
  query FranchisesListQuery {
    franchises {
      ...FranchiseQueryFranchise
    }
  }
  ${fragments.franchise}
`;



// WEBPACK FOOTER //
// ./src/queries/FranchisesList.js